import { formatInTimeZone } from 'date-fns-tz';
import { getDateOptions, getTimeOptions } from './GetOrderFilterOptions';
import { getBusinessTimezone } from './businessTimezone';
import timePickerReadiness from './timePickerReadiness';

// Use the same windows, delays, horizon, and intervals as the real picker.
// No stored customer acknowledgement can prove current restaurant availability.
export default function restaurantTimeAvailability(
  restaurant,
  type,
  time,
  now
) {
  const details = restaurant?.selectedRestaurantData;
  if (
    !restaurant?.selectedRestaurantId ||
    timePickerReadiness({
      details,
      mode: type,
      failed: restaurant?.restaurantDetailsError,
      loaded: restaurant?.restaurantDetailsLoaded,
    }) !== 'ready'
  )
    return false;
  try {
    const timezone = getBusinessTimezone(details.timezone);
    const clock = new Date(now);
    const start = Number(time.value.start);
    const day = formatInTimeZone(
      new Date(start * 1000),
      timezone,
      'yyyy-MM-dd'
    );
    if (
      !getDateOptions(timezone, clock).some(
        (date) =>
          formatInTimeZone(
            new Date(date.value * 1000),
            timezone,
            'yyyy-MM-dd'
          ) === day
      )
    )
      return false;
    return getTimeOptions({
      type,
      epoch: start,
      restaurantDetails: details,
      now: clock,
    }).some(
      (slot) =>
        slot.type === 'target' &&
        Number(slot.value.start) === start &&
        Number(slot.value.end) === Number(time.value.end)
    );
  } catch (error) {
    return false;
  }
}
